import { create } from 'zustand';
import { subscribeAudioWorkShutdown } from '../audioWorkBarrier';
import { type SessionRecordingStore } from '../types';
import { createBackupSlice } from './backupSlice';
import { createChunkSlice } from './chunkSlice';
import { createConnectivitySlice } from './connectivitySlice';
import { createHydrationSlice } from './hydrationSlice';
import { interruptForAudioShutdown } from './interruptForAudioShutdown';
import { createRecordingSlice } from './recordingSlice';
import { createTaskQueueSlice } from './taskQueueSlice';
export {
  prepareWriteFenceForHydrate,
  type FenceRecoveryOutcome,
} from '../persistenceV2/writeFence';

export const useSessionRecordingStore = create<SessionRecordingStore>((...args) => ({
  ...createRecordingSlice(...args),
  ...createTaskQueueSlice(...args),
  ...createChunkSlice(...args),
  ...createBackupSlice(...args),
  ...createHydrationSlice(...args),
  ...createConnectivitySlice(...args),
}));

subscribeAudioWorkShutdown(() =>
  interruptForAudioShutdown(() => useSessionRecordingStore.getState())
);
